import { IGameProvider } from "@base/features/game/model/interfaces";
import { container } from "tsyringe";

export default function CribbageOption(props: {children: JSX.Element}) {
  const gameProvider: IGameProvider = container.resolve('gameProvider');
  return gameProvider.GAME_ID === 4 ? props.children : null;
}
